import { appConfig } from "./app.config";

export const appAsset = {
  logo: `${appConfig.assetPath}/icon-512x512.png?${new Date().toISOString()}`,
  bukoLogo: `${appConfig.publicAssetPath}/bukolabs-logo.webp?${new Date().toISOString()}`,
  page404: "/404.png",
  loginBg: `${appConfig.assetPath}/login-bg-1.jpg?${new Date().toISOString()}`,
  loginBg2: `${appConfig.assetPath}/login-bg-2.jpg?${new Date().toISOString()}`,
};
